import * as Sentry from "@sentry/react";

export const COMMON_IGNORE_ERRORS = [
  "ResizeObserver loop limit exceeded",
  "ResizeObserver loop completed with undelivered notifications.",
  "Failed to read the 'localStorage' property from 'Window': Access is denied for this document.",
  "The operation is insecure.",
  "Failed to read the 'sessionStorage' property from 'Window': Access is denied for this document.",
  "Non-Error promise rejection captured",
  "Request aborted",
  "The user aborted a request",
  "Network Error",
];

/** Match Sentry's substring behavior for ignored error messages in tests. */
export const isIgnoredErrorMessage = (
  message: string,
  ignoreErrors: string[]
) => ignoreErrors.some((ignoreError) => message.includes(ignoreError));

interface SentryConfig {
  dsn: string;
  release: string;
  environment: string;
  enabled: boolean;
  tracesSampleRate?: number;
  maxBreadcrumbs?: number;
  normalizeDepth?: number;
  ignoreErrors?: string[];
}

export const initSentry = (config: SentryConfig) => {
  Sentry.init({
    dsn: config.dsn,
    integrations: [],
    release: config.release,
    environment: config.environment,
    tracesSampleRate: config.tracesSampleRate ?? 0,
    maxBreadcrumbs: config.maxBreadcrumbs ?? 50,
    normalizeDepth: config.normalizeDepth ?? 10,
    ignoreErrors: config.ignoreErrors ?? COMMON_IGNORE_ERRORS,
    enabled: config.enabled,
  });
};
